<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin"></div>
    </Transition>

    <v-form :name="formProps.formName"
            @keyup.enter="autoSave = true">
        <TabView scrollable
                 style="overflow: visible"
                 :pt="{ panelContainer: { class: 'form-tab-panel' } }">
            <TabPanel :header="__('Basic data')"
                      headerClass="form-tab-header">
                <div class="grid">
                    <FormStaticText label="Operation date"
                                    size="4"
                                    labelClass="static-text-label"
                                    class="static-text-content"
                                    :content="crud.created_at" />

                    <FormStaticText label="User"
                                    size="4"
                                    labelClass="static-text-label"
                                    class="static-text-content"
                                    :content="crud.user" />

                    <FormStaticText label="From"
                                    size="4"
                                    labelClass="static-text-label"
                                    class="static-text-content"
                                    :content="crud.from" />
                </div>
                <div class="grid">
                    <FormStaticText label="To"
                                    size="4"
                                    labelClass="static-text-label"
                                    class="static-text-content"
                                    :content="crud.to" />

                    <FormStaticText label="Cc"
                                    size="4"
                                    labelClass="static-text-label"
                                    class="static-text-content"
                                    :content="crud.cc" />

                    <FormStaticText label="Bcc"
                                    size="4"
                                    labelClass="static-text-label"
                                    class="static-text-content"
                                    :content="crud.bcc" />
                </div>
                <div class="grid">
                    <FormStaticText label="Subject"
                                    labelClass="static-text-label"
                                    class="static-text-content"
                                    :content="crud.subject" />
                </div>
                <div class="grid">
                    <FormStaticText label="Body"
                                    labelClass="static-text-label"
                                    class="static-text-content"
                                    :content="crud.body" />
                </div>
            </TabPanel>
        </TabView>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled"
                         v-model:autoSave="autoSave">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import { validation, initForm } from '@pages/Helper/crud_utils.js'
import FormStaticText from '@crud/FormStaticText.vue'
import FormButtons from '@crud/FormButtons.vue'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(false)
const autoSave = ref(false)

const crud = ref({})
const buttonsVisibility = ref({})

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, null, null, buttonsVisibility)
})

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
